import React, { useEffect, useState } from "react";
import notificationBell from "../../static/images/notificationBell.gif";
export default function MotorSendMessage({
  setMessage,
  message,
  sendAfterEnter,
  send,
  uploadFile,
  disableInput,
  agentName,
  botName,
  isOfflineWorkingHour,
  offWorkingHourMsg
}) {

  const [advisorStatus, setAdvisorStatus] = useState(true)

  useEffect(() => {
    if (agentName) {
      setAdvisorStatus(false)
    } else if (!agentName && isOfflineWorkingHour) {
      setAdvisorStatus(true);
    }
  }, [agentName, isOfflineWorkingHour]);

  return (
    <>
      {advisorStatus && isOfflineWorkingHour ?
        <>
          <div className="activeAgent">
            <div className="alertbox"><img src={notificationBell} /></div>
            {offWorkingHourMsg}
            <div className="close" onClick={() => { setAdvisorStatus(false) }}>✕</div>
          </div>
        </>
        : ''
      }

      <textarea
        value={message}
        style={{ flex: 1 }}
        maxLength={1024}
        // placeholder={disableInput ? "Please select an option... " : "Send a message..."}
        placeholder={"Type your query..."}
        label=""
        disabled={!botName && !agentName}//{!agentName}
        required
        onChange={(event) => setMessage(event.currentTarget.value)}
        onKeyDown={(e) => sendAfterEnter(e)}
      />
      {agentName ?
        <label className="fileInput">
          <input type={'file'} onChange={(event) => uploadFile(event.target.files)}></input>
        </label>
        : null}
      <button disabled={!botName && !agentName} className="SendMsgbutton" onClick={send}>Send</button>
    </>
  );
}
